import { useEffect, useRef, useState } from 'react';

const useScrollHeader = (threshold = 56) => {
  const [scrollY, setScrollY] = useState(0);
  const [showHeader, setShowHeader] = useState(true);
  const prevScrollYRef = useRef(0);
  const scrollUpDeltaRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const prev = prevScrollYRef.current;

      if (currentScrollY > prev) {
        scrollUpDeltaRef.current = 0;
        if (currentScrollY > threshold) setShowHeader(false);
      } else if (currentScrollY < prev) {
        scrollUpDeltaRef.current += prev - currentScrollY;
        if (scrollUpDeltaRef.current > threshold) setShowHeader(true);
      }

      prevScrollYRef.current = currentScrollY;
      setScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  return { showHeader, scrollY };
};

export default useScrollHeader;
